const cz = {
  // Navbar
  nav: {
    features: "Funkce",
    pricing: "Ceník",
    getStarted: "Začít",
    signIn: "Přihlásit se",
    profile: "Profil",
    atsCheck: "ATS kontrola zdarma",
    atsCheckBadge: "Zdarma",
    requestDemo: "Vyžádat demo",
  },

  // Hero
  hero: {
    badge: "Příprava na pohovor s AI",
    titleLine1: "Najděte svá slabá místa",
    titleLine2: "dříve než tazatel",
    subtitle: "Nahrajte svůj životopis a získejte okamžitou zpětnou vazbu od AI k silným stránkám i mezerám. Poté absolvujte plný adaptivní hlasový pohovor přizpůsobený vaší cílové pozici s hloubkovou analýzou připravenosti.",
    subtitleSignedIn: "Vložte popis pozice — přizpůsobíme otázky vašemu životopisu a spustíme adaptivní hlasový pohovor s hloubkovou analýzou připravenosti.",
    placeholder: "Sem vložte text popisu pozice...",
    analyzing: "Připravujeme pohovor...",
    analyzeBtn: "Spustit pohovor",
    analyzingHint: "U delších popisů to může trvat až 20 sekund.",
    tryAgain: "Zkusit znovu",
    trustPrivate: "100% soukromé",
    trustFaang: "Kalibrace na FAANG",
    trustVoice: "Hlasový pohovor",
  },

  // JD section for signed-in users (above JD textarea)
  jdSection: {
    title: "Vložte popis pozice — začněte svůj pohovor",
    subtitle: "Z popisu pozice vyextrahujeme klíčové kompetence a spustíme hlasový pohovor kalibrovaný na vaše zkušenosti.",
  },

  // Preview Questions
  preview: {
    title: "3 náročné otázky zdarma",
    competenciesFound: "nalezených kompetencí",
    hard: "Náročná",
    medium: "Střední",
    behavioral: "Behaviorální",
    startBtn: "🎙️ Spustit plný hlasový pohovor",
    startDesc: "Odemkněte adaptivního AI tazatele, který najde hranice vašich znalostí",
    questionPrefix: "Hloubková otázka na",
  },

  // Features
  features: {
    voiceTitle: "Hlasový pohovor v reálném čase",
    voiceDesc: "Mluvte přirozeně. Naše AI naslouchá, rozumí a klade hlubší otázky — přesně jako zkušený senior tazatel.",
    boundaryTitle: "Detekce hranic znalostí",
    boundaryDesc: "AI se nespokojí s povrchními odpověďmi. Postupně se zavrtává do tématu, dokud nezjistí přesně, kde vaše znalosti končí.",
    analyticsTitle: "Hloubková analýza připravenosti",
    analyticsDesc: "Radarové grafy, analýza mezer, vzorové odpovědi a skóre připravenosti, které lze sdílet na LinkedIn.",
  },

  // Pricing
  pricing: {
    title: "Jednoduchý a transparentní ceník",
    subtitle: "Jedna analýza je zdarma. Odemkněte plné hloubkové pohovory za méně než schůzku u kávy.",
    freeTitle: "Náhled zdarma",
    freeFeature1: "1 analýza popisu pozice",
    freeFeature2: "3 náročné otázky",
    freeFeature3: "Plný hlasový pohovor",
    freeFeature4: "Zpráva o připravenosti",
    currentPlan: "Aktuální plán",
    paidTitle: "Plný přístup",
    paidPrice: "$5",
    paidSub: "3 plné hloubkové pohovory",
    paidFeature1: "Neomezené analýzy popisů pozic",
    paidFeature2: "3 plné hlasové pohovory",
    paidFeature3: "Podrobné zprávy o připravenosti",
    paidFeature4: "Skóre ke sdílení na LinkedIn",
    paidBtn: "Získat plný přístup",
    mostPopular: "NEJOBLÍBENĚJŠÍ",
  },

  // Social proof
  social: {
    trustedBy: "Inženýři se připravují na pohovory ve více než 100 firmách, včetně",
  },

  // Footer
  footer: {
    copyright: "© 2026 HireFit. Všechna práva vyhrazena.",
    privacy: "Soukromí",
    terms: "Podmínky",
    contact: "Kontakt",
    forBusinesses: "Pro firmy",
  },

  // For Businesses landing page (/for-companies)
  forCompanies: {
    title: "Najímejte chytřeji s AI hlasovými pohovory",
    subtitle:
      "Vytvořte pozici, sdílejte odkaz a nechte naši AI vést s každým kandidátem skutečný hlasový pohovor. Získáte zpět strukturovanou zprávu — ohodnocené kompetence, kompletní přepis a životopis ke stažení — bez hodiny na Zoom hovoru.",
    step1Title: "Vytvořte pozici",
    step1Desc:
      "Vložte popis pozice, zvolte délku pohovoru a úroveň kandidáta. Automaticky z toho vytvoříme seznam kompetencí.",
    step2Title: "Sdílejte odkaz pro kandidáty",
    step2Desc:
      "Každá pozice získá veřejnou URL. Kandidáti nahrají životopis, zanechají kontaktní údaje a rovnou se pustí do živého AI hlasového pohovoru — bez registrace.",
    step3Title: "Procházejte zprávy ve svém CRM",
    step3Desc:
      "Každý dokončený pohovor přistane jako karta se skóre kompetencí, verdiktem, kompletním přepisem a životopisem v PDF. Přesouvejte kandidáty do stavu Postoupil nebo Zamítnut jedním kliknutím — zamítnutí kandidáti dokonce automaticky dostanou zdvořilý e-mail se zpětnou vazbou.",
    howItWorks: "Jak to funguje",
    ctaButton: "Otevřít své CRM →",
    ctaNote: "Zaregistrujte se nebo přihlaste pracovním e-mailem. Začněte zdarma.",
    back: "← Zpět na přípravu na pohovor",
  },

  // B2B pricing (public table on /for-companies + CRM billing page)
  b2bPricing: {
    title: "Ceník, který roste s vaším náborem",
    subtitle:
      "Každý plán zahrnuje AI hlasové pohovory, strukturované zprávy a CRM pro kandidáty. Začněte zdarma a upgradujte, jak rostete.",
    perMonth: "/měs",
    free: "Zdarma",
    custom: "Na míru",
    mostPopular: "Nejoblíbenější",
    currentPlan: "Aktuální plán",
    subscribe: "Předplatit",
    getStarted: "Začít",
    contactSales: "Kontaktovat obchod",
    yourPlan: "Váš plán",
    interviewsThisMonth: "Pohovory tento měsíc",
    activeVacancies: "Aktivní pozice",
    unlimited: "Neomezeně",
    renews: "Obnovuje se",
    upgradeSuccess: "Vše je připraveno — váš plán je nyní aktivní.",
    upgradeCanceled: "Platba zrušena. Nebyly provedeny žádné změny.",
    vacancyLimitReached: "Dosáhli jste limitu pozic ve svém plánu. Pro přidání dalších upgradujte.",
    plans: {
      starter: {
        name: "Starter",
        tagline: "Malé firmy / zkušební provoz",
        features: [
          "50 AI pohovorů / měs",
          "1 aktivní pozice",
          "Strukturované zprávy a přepisy",
          "CRM pro kandidáty",
        ],
      },
      pro: {
        name: "Pro",
        tagline: "Střední firmy / náboráři",
        features: [
          "100 AI pohovorů / měs",
          "Až 3 pozice",
          "Vše ze Starter",
          "E-mailová upozornění",
        ],
      },
      team: {
        name: "Team",
        tagline: "Personální agentury",
        features: [
          "300 AI pohovorů / měs",
          "Až 10 pozic",
          "Vše z Pro",
          "Prioritní zpracování",
        ],
      },
      enterprise: {
        name: "Enterprise",
        tagline: "Korporace / velká HR oddělení",
        features: [
          "Neomezené pohovory a pozice",
          "Přizpůsobení na míru",
          "Prioritní podpora",
          "Dedikovaný onboarding",
        ],
      },
    },
  },

  // ATS check (/ats-check)
  atsCheck: {
    title: "ATS kontrola životopisu zdarma",
    subtitle:
      "Získejte za 15 sekund audit svého životopisu na úrovni náborového manažera. Vložte i popis pozice a ukážeme vám, která klíčová slova vám chybí a kde vaše zkušenosti nestačí.",
    signedOutCta: "Přihlaste se a spusťte ATS kontrolu zdarma",
    signedOutHint: "Potřebujeme vás přihlásit, abychom mohli sledovat vašich 5 kontrol zdarma za 24 hodin.",
    resumeSectionTitle: "1. Váš životopis",
    tabFile: "Nahrát soubor",
    tabText: "Vložit text",
    fileCta: "Přetáhněte sem nebo klikněte pro nahrání",
    fileHint: "PDF nebo DOCX, až 10 MB",
    fileTooLarge: "Soubor je příliš velký (max. 10 MB).",
    fileWrongType: "Podporovány jsou pouze soubory PDF nebo DOCX.",
    textPlaceholder: "Sem vložte celý text svého životopisu...",
    jdSectionTitle: "2. Popis pozice (volitelné)",
    jdSectionHint:
      "Přidejte popis pozice a my vám navíc přesně ukážeme, která klíčová slova vám chybí a kde máte mezery ve zkušenostech.",
    jdPlaceholder: "Sem vložte popis pozice a získejte shodu klíčových slov a analýzu mezer...",
    analyzeBtn: "Analyzovat můj životopis",
    analyzing: "Analyzujeme váš životopis...",
    quotaLabel: "Dnes využito kontrol zdarma: {used}/{limit}",
    newCheckBtn: "Spustit další kontrolu",
    resultTitle: "Vaše ATS analýza",
    scoreOutOf: "ze 100",
    scoreExcellent: "Výborné — připraveno pro ATS",
    scoreGood: "Dobré — potřeba drobné úpravy",
    scoreAverage: "Průměrné — potřeba skutečná vylepšení",
    scoreBelow: "Pod hranicí — pravděpodobně vyřazeno",
    issuesTitle: "Problémy k opravě",
    noIssues: "Nebyly zjištěny žádné závažné problémy.",
    severityHigh: "Vysoká",
    severityMedium: "Střední",
    severityLow: "Nízká",
    categoryFormatting: "Formátování",
    categoryKeywords: "Klíčová slova",
    categoryStructure: "Struktura",
    categoryClarity: "Srozumitelnost",
    categoryQuantification: "Kvantifikace",
    categoryExperience: "Zkušenosti",
    categoryContact: "Kontakt",
    bulletsTitle: "Přepsané odrážky",
    bulletsHint: "Silnější verze s metrikami a dopadem — stačí zkopírovat a vložit.",
    bulletOriginal: "Vaše verze",
    bulletImproved: "Vylepšeno",
    bulletReason: "Proč je to lepší",
    copy: "Kopírovat",
    copied: "Zkopírováno!",
    keywordMatchTitle: "Shoda klíčových slov",
    keywordScoreLabel: "Skóre shody",
    keywordMatched: "Shoda ve vašem životopise",
    keywordMissing: "Chybí ve vašem životopise",
    keywordSuggestions: "Jak se zlepšit",
    gapTitle: "Analýza mezer",
    gapAligned: "Co odpovídá",
    gapGaps: "Co chybí",
    gapRecommendations: "Doporučení",
    missingResume: "Nejprve prosím nahrajte nebo vložte svůj životopis.",
    rateLimited: "Dosažen denní limit. Můžete spustit 5 kontrol za 24 hodin — vraťte se zítra.",
    genericError: "Něco se pokazilo. Zkuste to prosím znovu.",
    tryFullInterview: "Chcete dál zkusit plný hlasový pohovor?",
    tryFullInterviewDesc:
      "Vyzkoušejte svůj životopis v adaptivním AI pohovoru přizpůsobeném vaší cílové pozici.",
    tryFullInterviewBtn: "Spustit přípravu na pohovor →",
  },

  // Free trial banner
  trial: {
    daysLeft: "zbývá {n} dní",
    freeInterviews: "{n} pohovorů zdarma",
    expired: "Zkušební verze vypršela",
    buyNow: "Koupit pohovory",
  },

  // Auth & quota
  quota: {
    signInToStart: "Přihlaste se a začněte",
    noInterviewsRemaining: "Nezbývají žádné pohovory",
    buyInterviews: "Koupit pohovory",
    buyMore: "Koupit další pohovory — $5",
    checkingQuota: "Ověřujeme přístup...",
  },

  // Paywall modal (legacy — used by hillel page)
  paywall: {
    title: "Odemknout plný pohovor",
    desc: "Získejte kompletní adaptivní hlasový pohovor s hloubkovou analýzou připravenosti za $5 (3 pohovory).",
    btn: "Získat plný přístup — $5",
    alreadyPaid: "Už máte zaplaceno? Zadejte svůj e-mail:",
    emailPlaceholder: "vas@email.com",
    check: "Ověřit",
    tryFree: "Vyzkoušet zdarma (5min demo)",
    allUsed: "Všechny pohovory vyčerpány. Pro další si je kupte znovu.",
    notFound: "Pro tento e-mail nebyl nalezen žádný nákup.",
    checkFailed: "Ověření se nezdařilo. Zkuste to znovu.",
    havePromo: "Máte promo kód?",
    promoPlaceholder: "APEX-XXXXXX",
    redeemBtn: "Uplatnit",
    promoSuccess: "Promo kód uplatněn! Spouštíme pohovor...",
  },

  // Interview Chat
  chat: {
    topicsToCover: "📋 Témata k probrání",
    standardMode: "Standardní režim",
    liveMode: "⚡ Režim LIVE (Beta)",
    beginInterview: "Začít pohovor",
    backBtn: "Zpět",
    voiceInterview: "Hlasový pohovor",
    liveInterview: "⚡ Živý pohovor",
    endInterview: "Ukončit pohovor",
    you: "Vy",
    interviewer: "Tazatel",
    aiSpeaking: "🔊 AI mluví...",
    aiListening: "🎤 Naslouchám...",
    processing: "Zpracováváme váš hlas...",
    thinking: "Přemýšlím...",
    liveSpeak: "⚡ Živě — mluvte přirozeně",
    connecting: "Připojuji...",
    disconnected: "Odpojeno",
    timeWarning: "zbývá v demu zdarma. Zaplaťte a odemkněte plné pohovory.",
    timeEndingSoon: "do konce pohovoru.",
    timeCutoff: "⏱️ Čas dema zdarma vypršel. Generujeme vaši dílčí zprávu...",
    audioError: "⚠️ Jejda, něco se pokazilo. Už na tom pracujeme — zkuste to prosím za pár sekund znovu.",
    retryBtn: "Zkusit znovu",
    dismissBtn: "Zavřít",
    startMessage: "Začít pohovor.",
    doneSpeakingBtn: "Domluvil/a jsem",
    micListening: "Naslouchám",
    cameraPromptTitle: "Zapněte kameru",
    cameraPromptDesc: "Během pohovoru bychom rádi nahrávali vaši tvář. Pomáhá to hodnotit neverbální komunikaci a zajišťuje integritu pohovoru. Kamera je volitelná, ale doporučená.",
    cameraActive: "Kamera je zapnutá",
    cameraDenied: "Přístup ke kameře byl odepřen",
    cameraRequesting: "Žádám o přístup...",
    cameraEnable: "Zapnout kameru",
    cameraStartInterview: "Začít pohovor s kamerou",
    cameraSkip: "Přeskočit — pokračovat bez kamery",
    gdprTitle: "Souhlas se zpracováním údajů",
    gdprDesc: "Během tohoto pohovoru budeme pomocí AI nahrávat a zpracovávat vaše hlasové odpovědi, abychom vyhodnotili vaše technické kompetence. Můžete být také požádáni o zapnutí webkamery a sdílení obrazovky. Vaše údaje jsou zpracovávány v souladu s GDPR a našimi Zásadami ochrany soukromí.",
    gdprPoint1: "Váš hlas bude nahrán a přepsán pro analýzu AI",
    gdprPoint2: "Vaše webkamera a obrazovka mohou být nahrávány pro zajištění integrity pohovoru",
    gdprPoint3: "Vaše odpovědi budou použity ke generování zprávy o připravenosti",
    gdprPoint4: "Smazání svých údajů můžete kdykoli vyžádat",
    gdprAccept: "Souhlasím — pokračovat",
    gdprDecline: "Odmítnout",
    gdprPrivacyLink: "Přečíst naše Zásady ochrany soukromí",
  },

  // Report
  report: {
    title: "Zpráva o připravenosti",
    subtitle: "Hodnocení hloubkového pohovoru s AI",
    shareBtn: "Sdílet na LinkedIn",
    shareCopied: "Zkopírováno! Vložte na LinkedIn",
    overallReadiness: "Celková připravenost",
    readyScreening: "Připraven/a na screening",
    needsPrep: "Potřebuje více přípravy",
    skillBreakdown: "Rozpis dovedností",
    you: "Vy",
    passingBar: "Hranice úspěšnosti",
    focusArea: "Oblast k zaměření",
    criticalGaps: "Kritické mezery ve znalostech",
    areasNeedImprovement: "oblastí potřebuje zlepšení",
    aiAnalysis: "Analýza AI",
    modelAnswer: "Vzorová odpověď",
    majorMiss: "Zásadní nedostatek",
    needsWork: "Potřebuje práci",
    redFlags: "Varovné signály",
    studyPlan: "Doporučený studijní plán",
    anotherRound: "Připraveni na další kolo?",
    anotherRoundDesc: "Cvik dělá mistra. Spusťte nový pohovor, zlepšete svá slabá místa a zvyšte své skóre připravenosti.",
    startNew: "Spustit nový pohovor",
    shareTitle: "Výsledky zkopírovány!",
    shareDesc: "Vaše výsledky pohovoru jsou ve schránce. Stiskněte",
    shareDescCtrl: "Ctrl+V",
    shareDescOr: "nebo",
    shareDescCmd: "Cmd+V",
    shareDescEnd: "a vložte je do svého příspěvku na LinkedIn.",
    openLinkedIn: "Otevřít LinkedIn",
  },

  // Profile page
  profile: {
    title: "Můj profil",
    interviews: "Historie pohovorů",
    noInterviews: "Zatím žádné pohovory",
    remaining: "zbývajících pohovorů",
    buyMore: "Koupit +3 pohovory ($5)",
    verdict: "Verdikt",
    viewReport: "Zobrazit zprávu",
    jobDescription: "Popis pozice",
    competencies: "Skóre kompetencí",
    redFlags: "Varovné signály",
    studyPlan: "Studijní plán",
    loading: "Načítám profil...",
    resume: "Můj životopis",
    resumeInfo: "Váš životopis bude uložen a může být sdílen s partnerskými firmami",
    uploadResume: "Nahrát životopis",
    uploadedAt: "Nahráno",
    fileTooLarge: "Soubor je příliš velký (max. 10 MB)",
    invalidFileType: "Povoleny jsou pouze soubory PDF a DOCX",
  },

  // Loading states
  loading: {
    verifyingPayment: "Ověřujeme vaši platbu...",
    generatingReport: "Generujeme vaši zprávu o připravenosti...",
  },

  reportSkeleton: {
    title: "Sestavujeme vaši zprávu",
    subtitle: "Ještě pár sekund — analyzujeme pohovor a hodnotíme každou dovednost.",
    hint: "Nechte tuto kartu otevřenou — zpráva se zde objeví automaticky.",
    stages: [
      "Čteme váš rozhovor...",
      "Hodnotíme kompetence...",
      "Hledáme slabá místa...",
      "Připravujeme váš studijní plán...",
      "Dokončujeme...",
    ],
  },

  // Language switcher
  lang: {
    en: "EN",
    ru: "RU",
    cz: "CZ",
  },

  // Resume Input (resume-first landing)
  resumeInput: {
    tabUpload: "Nahrát PDF",
    tabPaste: "Vložit text",
    uploadBtn: "Nahrát životopis",
    dragDropHint: "Přetáhněte sem své PDF nebo DOCX, nebo klikněte pro výběr",
    pastePlaceholder: "Sem vložte text svého životopisu...",
    analyzeBtn: "Analyzovat životopis",
    analyzing: "Analyzuji...",
    fileTooLarge: "Soubor je příliš velký. Maximální velikost je 10 MB.",
    invalidFileType: "Neplatný typ souboru. Nahrajte prosím soubor PDF nebo DOCX.",
  },

  // Resume Feedback (resume-first landing)
  resumeFeedback: {
    sectionTitle: "Analýza životopisu",
    scoreLabel: "Skóre životopisu",
    strengthsTitle: "Silné stránky",
    improvementsTitle: "Oblasti ke zlepšení",
    overallAssessmentTitle: "Celkové hodnocení",
  },

  // Post-Analysis CTA section (resume-first landing)
  postAnalysis: {
    ctaHeading: "Chcete cvičný pohovor na základě svého životopisu?",
    ctaSubtext: "Náš AI tazatel vám položí cílené otázky podle vašich zkušeností a dovedností — přesně jako naostro.",
    signInBtn: "Přihlaste se a začněte",
    freeTrialText: "3 pohovory zdarma po registraci",
    pricingInfo: "$5 za další 3 pohovory",
    feature1: "Hlasový pohovor se zpětnou vazbou od AI v reálném čase",
    feature2: "Detekce hranic znalostí",
    feature3: "Hloubková analýza připravenosti a zpráva",
  },

  // Resume status (Landing for signed-in users)
  resumeStatus: {
    attached: "Váš životopis",
    uploadedAt: "Aktualizováno",
    changeBtn: "Změnit",
    noResume: "Zatím nebyl nahrán žádný životopis",
    noResumeHint: "Přidejte svůj životopis, aby otázky odpovídaly vašim zkušenostem",
    uploadBtn: "Nahrát",
    uploadTitle: "Nahrát životopis",
    replaceTitle: "Nahradit životopis",
    cancel: "Zrušit",
    syncing: "Ukládáme váš životopis...",
    syncingHint: "Trvá to pár sekund — extrahujeme text pro pohovor.",
  },

  // Success page
  success: {
    title: "Platba úspěšná!",
    desc: "Nyní máte přístup ke 3 plným hloubkovým pohovorům.",
    email: "Účet",
    startBtn: "Spustit pohovor",
    errorTitle: "Něco se pokazilo",
    errorDesc: "Nepodařilo se nám ověřit vaši platbu. Pokud už máte zaplaceno, zadejte svůj e-mail na hlavní stránce.",
    goHome: "Přejít na domovskou stránku",
  },

  // B2B CRM
  crm: {
    nav: {
      homeAria: "HireFit CRM — domů",
      billing: "Fakturace",
      signIn: "Přihlásit se",
    },
    landing: {
      badge: "Náborová platforma s AI",
      title: "Najímejte chytřeji s AI hlasovými pohovory.",
      subtitle:
        "Vytvořte pozici, sdílejte odkaz a nechte HireFit vést s každým kandidátem skutečný hlasový pohovor — získáte zpět ohodnocenou zprávu, kompletní přepis a životopis. Bez hodiny na Zoomu.",
      openCrm: "Otevřít své CRM",
      seeHow: "Podívejte se, jak to funguje",
      trustFreeToStart: "Začněte zdarma",
      trustNoCard: "Bez platební karty",
      trustSetup: "Nastavení za 2 minuty",
      feature1Title: "Vytvářejte pozice během pár minut",
      feature1Desc:
        "Vložte popis pozice, přidejte vlastní screeningové otázky a získejte brandovanou stránku pohovoru s jedinečnou URL — připravenou ke sdílení s kandidáty.",
      feature2Title: "AI vede pohovory s kandidáty 24/7",
      feature2Desc:
        "Náš AI tazatel vede strukturované technické i behaviorální pohovory podle vašich požadavků na pozici — bez nutnosti plánování.",
      feature3Title: "Sledujte výsledky a porovnávejte",
      feature3Desc:
        "Získejte podrobné skóre kompetencí, varovné signály a studijní plány pro každého kandidáta. Porovnávejte uchazeče vedle sebe ve svém dashboardu.",
      feature4Title: "Naplánujte hovory okamžitě",
      feature4Desc:
        "Posílejte pozvánky z Calendly přímo z profilu kandidáta. Pište poznámky, sledujte pokrok a posouvejte ty nejlepší talenty dál — vše na jednom místě.",
      sectionTitle: "Vše, co potřebujete pro chytřejší nábor",
      sectionSubtitle:
        "Od vytvoření pozice po hodnocení kandidátů — zefektivněte celý svůj náborový proces pomocí AI.",
      signInCta: "Přihlaste se a začněte",
    },
    dashboard: {
      title: "Pozice",
      subtitle: "Spravujte své inzeráty a sledujte kandidáty",
      newVacancy: "Nová pozice",
      loading: "Načítám pozice…",
      retry: "Zkusit znovu",
      emptyTitle: "Zatím žádné pozice",
      emptyDesc: "Vytvořte svou první pozici a začněte vést pohovory s kandidáty pomocí AI.",
      emptyCta: "Vytvořit první pozici",
      colVacancy: "Pozice",
      colCreated: "Vytvořeno",
      colCandidates: "Kandidáti",
      colPublicUrl: "Veřejná URL",
      colActions: "Akce",
      copyUrl: "Kopírovat URL",
      copied: "Zkopírováno!",
      deleteVacancy: "Smazat pozici",
      deleteConfirm: "Smazat tuto pozici? Kandidáti k ní již nebudou mít přístup.",
    },
    vacancy: {
      loadingCandidates: "Načítám kandidáty…",
      backToVacancies: "Zpět na pozice",
      backToAdmin: "Zpět do administrace",
      edit: "Upravit",
      editVacancy: "Upravit pozici",
      updatedSuccess: "Pozice byla úspěšně aktualizována!",
      title: "Název *",
      jobDescription: "Popis pozice *",
      duration: "Délka",
      level: "Úroveň",
      languages: "Jazyky",
      resultEmails: "E-maily pro výsledky",
      interviewFocus: "Zaměření pohovoru",
      interviewAvoid: "Čemu se vyhnout",
      saving: "Ukládám…",
      saveChanges: "Uložit změny",
      cancel: "Zrušit",
      statTotalCandidates: "Celkem kandidátů",
      statAverageScore: "Průměrné skóre",
      statReadiness: "Připravenost",
      filterAll: "Vše",
      filterNew: "Noví",
      filterInProgress: "Probíhá",
      filterAdvanced: "Postoupili",
      filterRejected: "Zamítnuti",
      noCandidatesWithStatus: "Žádní kandidáti s tímto stavem.",
      emptyTitle: "Zatím žádní kandidáti",
      emptyDesc: "Sdílejte odkaz na pozici s kandidáty a začněte přijímat výsledky pohovorů.",
      colCandidate: "Kandidát",
      colStatus: "Stav",
      colCountry: "Země",
      colInterviewDate: "Datum pohovoru",
      colAvgScore: "Prům. skóre",
      colVerdict: "Verdikt",
      colContacts: "Kontakty",
      colFiles: "Soubory",
      fileScreenRecording: "Nahrávka obrazovky",
      fileWebcamRecording: "Nahrávka z webkamery",
    },
    candidate: {
      loading: "Načítám kandidáta…",
      backToCandidates: "Zpět na kandidáty",
      back: "Zpět",
      screenRecording: "Nahrávka obrazovky",
      webcamRecording: "Nahrávka z webkamery",
      statusLabel: "Stav:",
      avgScore: "prům. skóre",
      competencyBreakdown: "Rozpis kompetencí",
      modelAnswer: "Vzorová odpověď",
      translating: "Překládám zprávu z angličtiny…",
      redFlags: "Varovné signály",
      studyPlan: "Doporučený studijní plán",
      overallVerdict: "Celkový verdikt",
      notes: "Poznámky",
      scheduleCall: "Naplánovat hovor",
      calendlyLink: "Odkaz na Calendly",
      personalMessage: "Osobní zpráva",
      rejectTitle: "Zamítnout kandidáta",
      rejectPrompt: "Volitelně přidejte zprávu o zamítnutí:",
      rejectPlaceholder: "Důvod zamítnutí (volitelné)...",
      confirmRejection: "Potvrdit zamítnutí",
      cancel: "Zrušit",
    },
    status: {
      new: "nový",
      advanced: "postoupil",
      rejected: "zamítnut",
      inProgress: "probíhá",
    },
    newVacancy: {
      back: "Zpět na dashboard",
      heading: "Vytvořit novou pozici",
      subheading: "Nastavte inzerát a nechte AI automaticky vést pohovory s vašimi kandidáty.",
      companyLabel: "Název firmy",
      companyPlaceholder: "např. Acme Corp",
      companyHelper: "Použije se k vygenerování vaší jedinečné URL pozice.",
      titleLabel: "Název pozice",
      titlePlaceholder: "např. Senior Frontend Developer",
      jdLabel: "Popis pozice",
      cleanUp: "Vyčistit",
      cleaning: "Čistím…",
      jdPlaceholder: "Sem vložte popis pozice. Tlačítkem „Vyčistit“ odstraníte artefakty formátování.",
      jdHelper: "AI to použije ke generování otázek na pohovor. Vyčištění odstraní artefakty formátování ze zkopírovaného textu.",
      customQuestionsLabel: "Vlastní otázky na pohovor",
      customQuestionsHelper: "Přidejte otázky, které má AI tazatel položit. U každé otázky zvolte, zda se ptá před nebo po technickém hodnocení.",
      questionPlaceholder: "Zadejte otázku…",
      removeQuestion: "Odstranit otázku",
      addQuestion: "Přidat otázku",
      askLabel: "Ptát se:",
      askBefore: "Před pohovorem",
      askAfter: "Po pohovoru",
      customFieldPlaceholders: [
        "Kde se nacházíte?",
        "Jakou mzdu si představujete?",
        "Kdy můžete nastoupit?",
        "Jste otevřeni relokaci?",
        "Máte zkušenosti s prací na dálku?",
        "Jaká je vaše výpovědní lhůta?",
        "Máte povolení pracovat v této zemi?",
        "Jaká je vaše preferovaná pracovní doba?",
        "Máte naplánované nějaké cestování?",
        "Kterými jazyky plynně hovoříte?",
      ],
      durationLabel: "Délka pohovoru",
      durationHelper: "Ovládá hloubku a počet otázek, které AI tazatel položí.",
      durationScreening: "15 min (Screening)",
      duration30: "30 min",
      duration45: "45 min",
      duration60: "1 hodina",
      screeningBadge: "Screening",
      levelLabel: "Úroveň pozice",
      levelHelper: "AI nakalibruje obtížnost otázek a hodnocení podle očekávané úrovně.",
      levelIntern: "Stážista",
      levelJunior: "Junior",
      levelMiddle: "Middle",
      levelSenior: "Senior",
      levelLead: "Lead",
      levelPrincipal: "Principal",
      languagesLabel: "Jazyky pohovoru",
      languagesHelper: "Kandidáti si při zahájení pohovoru budou moci vybrat jeden z těchto jazyků.",
      langEn: "Angličtina",
      langRu: "Ruština",
      langCz: "Čeština",
      optional: "(volitelné)",
      focusLabel: "Zaměřit se na",
      focusPlaceholder: "např. Ptejte se na zkušenosti s ATS systémy, Boolean vyhledáváním, obsazováním technických rolí, prací s náborovými manažery...",
      focusHelper: "Naveďte AI, jaká témata má pokrýt. Pokud necháte prázdné, AI se rozhodne podle popisu pozice.",
      avoidLabel: "Vyhnout se otázkám",
      avoidPlaceholder: "např. Neptejte se na programování ani návrh systémů — jde o netechnickou roli...",
      avoidHelper: "Řekněte AI, co má přeskočit. Užitečné u netechnických rolí, kde popis pozice zmiňuje technologie jen jako kontext, ne jako požadavek.",
      resultEmailsLabel: "E-maily pro výsledky",
      resultEmailsPlaceholder: "email1@example.com, email2@example.com",
      resultEmailsHelper: "Volitelné. Výsledky pohovoru budou kromě e-mailu vašeho účtu zaslány i na tyto adresy.",
      submit: "Vytvořit pozici",
      submitting: "Vytvářím pozici…",
      successTitle: "Pozice vytvořena!",
      successSubtitle: "Sdílejte tento odkaz s kandidáty a začněte vést pohovory:",
      copy: "Kopírovat",
      copied: "Zkopírováno!",
      viewCandidates: "Zobrazit kandidáty",
      errCompanyRequired: "Název firmy je povinný",
      errMaxQuestions: "Povoleno je maximálně 10 vlastních otázek",
      errQuestionTooLong: "Otázka {n} přesahuje 200 znaků",
      errEmptyQuestion: "Otázka {n} je prázdná — zadejte text, nebo ji odeberte.",
      suggestionsLabel: "Návrhy (kliknutím přidáte):",
      errInvalidEmails: "Neplatné e-maily: {emails}",
      errCleanFailed: "Nepodařilo se vyčistit popis pozice",
      errCreateFailed: "Nepodařilo se vytvořit pozici",
    },
  },
} as const;

export default cz;
